import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa"; // tu peux changer d’icône si tu veux

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) { // après 300px de scroll on affiche
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    visible && (
      <button className="scroll-to-top" onClick={scrollToTop} aria-label="Retour en haut">
        <FaArrowUp size={20} />
      </button>
    )
  );
}
